export const servicePages = [
  {
    slug: 'social-media-marketing',
    title: 'Social Media Marketing',
    eyebrow: 'Est. 2026 - London',
    heroTitle: ['Redefining', 'the Digital', 'Storytelling'],
    heroDescription:
      'We blend data-driven strategy with high-end aesthetics to scale your brand presence.',
    heroStats: [
      { value: '20+', label: 'Brands scaled' },
      { value: '142%', label: 'Engagement lift' },
      { value: '9.1x', label: 'Average ROAS' },
    ],
    marquee: [
      'Brand Strategy',
      'Content Creation',
      'Influencer Marketing',
      'Analytics and Reporting',
      'Community Building',
      'Performance Marketing',
    ],
    serviceHeading: 'Scaling every brand with clarity',
    services: [
      {
        title: 'Brand Strategy',
        description: 'Audience research and positioning that makes your brand impossible to ignore.',
      },
      {
        title: 'Content Creation',
        description: 'Art direction, motion, and copy that stop the scroll and convert.',
      },
      {
        title: 'Analytics',
        description: 'Performance-focused execution with clean reporting across channels.',
      },
      {
        title: 'Influencer Marketing',
        description: 'Creator partnerships designed for trust, reach, and measurable impact.',
      },
    ],
    showcaseHeading: 'Style showcase',
    showcase: [
      {
        title: 'Vintage Soul, Modern Edge',
        description: 'A nostalgic blend of grain textures and retro palettes for a polished digital look.',
      },
      {
        title: 'Vibrant Storyteller',
        description: 'Maximalist layouts and saturated palettes built to command attention.',
      },
      {
        title: 'Next-Gen Visuals',
        description: 'Sleek dark aesthetics and geometric systems for modern brands.',
      },
    ],
    testimonials: [
      'They transformed a dead comment section into a high-trust brand community.',
      'They helped us find a voice that felt native and authentic to our audience.',
      'They connected engagement to revenue and made paid social predictable.',
    ],
    ctaTitle: 'Ready to go beyond digital?',
    ctaHighlight: 'Start your growth phase',
  },
  {
    slug: 'content-creation',
    title: 'Content Creation',
    eyebrow: 'Est. 2026 - London',
    heroTitle: ['Content', 'that Moves', 'People'],
    heroDescription:
      'We create high-impact visuals and storytelling assets designed to capture attention and drive action.',
    heroStats: [
      { value: '2000+', label: 'Assets created' },
      { value: '4.3x', label: 'Avg campaign lift' },
      { value: '8', label: 'Content formats mastered' },
    ],
    marquee: [
      'Brand Films',
      'Short-form Video',
      'Social Creatives',
      'Campaign Art Direction',
      'Performance Creatives',
      'Visual Storytelling',
    ],
    serviceHeading: 'Creative system built for scale',
    services: [
      {
        title: 'Creative Direction',
        description: 'Unified campaign concepts that align visual identity with business outcomes.',
      },
      {
        title: 'Video Production',
        description: 'From scripting to edit, we produce conversion-ready motion content.',
      },
      {
        title: 'Static Creative Design',
        description: 'Scroll-stopping graphics for ads, social, and retention campaigns.',
      },
      {
        title: 'Content Optimization',
        description: 'Iterative testing to improve retention, CTR, and conversion over time.',
      },
    ],
    showcaseHeading: 'Content showcase',
    showcase: [
      {
        title: 'Launch Storytelling',
        description: 'Narrative-first creative assets built for product drops and awareness.',
      },
      {
        title: 'Performance Creative Set',
        description: 'Variant packs designed to support paid campaign testing at speed.',
      },
      {
        title: 'Always-On Social System',
        description: 'A reusable monthly engine for consistent, high-quality brand content.',
      },
    ],
    testimonials: [
      'Their content quality and speed gave our campaigns a major competitive edge.',
      'They turned vague ideas into polished campaigns with clear creative direction.',
      'Our engagement and ad efficiency improved as soon as their system went live.',
    ],
    ctaTitle: 'Need content that converts?',
    ctaHighlight: 'Start your creative build',
  },
  {
    slug: 'seo',
    title: 'SEO',
    eyebrow: 'Est. 2026 - London',
    heroTitle: ['Architects', 'of Organic', 'Revenue'],
    heroDescription:
      'We combine technical SEO, topical strategy, and authority building to create durable search growth.',
    heroStats: [
      { value: '210%', label: 'Average organic growth' },
      { value: '85%', label: 'AI overview visibility' },
      { value: '12.4k', label: 'High-intent keywords won' },
    ],
    marquee: [
      'Agentic SEO',
      'Entity Optimization',
      'Technical Architecture',
      'Semantic Search',
      'E-E-A-T',
      'Digital PR',
    ],
    serviceHeading: 'The technical edge',
    services: [
      {
        title: 'AI and Agentic Optimization',
        description: 'Structure content for human readers and modern AI-powered discovery.',
      },
      {
        title: 'Topical Authority Mapping',
        description: 'Create topic clusters that establish category-level expertise.',
      },
      {
        title: 'Performance Architecture',
        description: 'Improve crawlability, page speed, and site health for long-term rankings.',
      },
      {
        title: 'Digital PR and Authority',
        description: 'Acquire quality mentions and links that compound domain strength.',
      },
    ],
    showcaseHeading: 'Case studies',
    showcase: [
      {
        title: 'Fintech Frontier',
        description: 'Scaled high-intent rankings to dominate category terms in a crowded market.',
      },
      {
        title: 'D2C Dominance',
        description: 'Topical expansion and authority work that drove sustained first-page coverage.',
      },
      {
        title: 'SaaS Scale',
        description: 'Improved global visibility for enterprise search opportunities.',
      },
    ],
    testimonials: [
      'They moved us from traffic growth to revenue-focused search growth.',
      'Their strategy outperformed larger competitors with smaller budgets.',
      'SEO became predictable once their technical and content framework was in place.',
    ],
    ctaTitle: 'The algorithm is evolving.',
    ctaHighlight: 'Start your SEO audit',
  },
  {
    slug: 'paid-ads',
    title: 'Paid Ads',
    eyebrow: 'Est. 2026 - London',
    heroTitle: ['Performance', 'Without', 'Compromise'],
    heroDescription:
      'We design full-funnel paid systems that maximize return while reducing wasted spend.',
    heroStats: [
      { value: '5.2x', label: 'Average ROAS' },
      { value: '35%', label: 'Lower CPA' },
      { value: '1.5M', label: 'Managed annual spend' },
    ],
    marquee: [
      'Predictive Bidding',
      'Meta Advantage',
      'Performance Max',
      'Precision Retargeting',
      'LTV Optimization',
      'Attribution Modeling',
    ],
    serviceHeading: 'Conversion logic',
    services: [
      {
        title: 'Full-Funnel Architecture',
        description: 'Connect awareness, consideration, and conversion campaigns into one system.',
      },
      {
        title: 'Creative Strategy',
        description: 'Build and test creative variants to improve CTR and conversion efficiency.',
      },
      {
        title: 'Predictive Scaling',
        description: 'Scale winning segments quickly while preserving efficiency metrics.',
      },
      {
        title: 'Granular Analytics',
        description: 'Track CAC, ROAS, and LTV in real time with clean decision dashboards.',
      },
    ],
    showcaseHeading: 'Ad success',
    showcase: [
      {
        title: 'Logistics Disruptor',
        description: 'Reduced cost-per-lead in a highly competitive B2B category.',
      },
      {
        title: 'Smart-Home Surge',
        description: 'Scaled paid social to consistently profitable return bands.',
      },
      {
        title: 'Risk Management Scale',
        description: 'Built a high-intent funnel that improved enterprise lead quality.',
      },
    ],
    testimonials: [
      'They turned ad spend into a measurable growth engine with clear attribution.',
      'We reached profitable scale faster than with any previous agency.',
      'Their optimization process improved both lead quality and efficiency.',
    ],
    ctaTitle: 'Ready for a profitable scale-up?',
    ctaHighlight: 'Request a free ad audit',
  },
  {
    slug: 'crm-automation',
    title: 'CRM & Automation',
    eyebrow: 'Est. 2026 - London',
    heroTitle: ['Architects', 'of Autonomous', 'Growth'],
    heroDescription:
      'We build CRM and workflow systems that remove manual bottlenecks and accelerate revenue.',
    heroStats: [
      { value: '65%', label: 'Reduction in manual tasks' },
      { value: '3.5x', label: 'Lead velocity increase' },
      { value: '24/7', label: 'Active engagement window' },
    ],
    marquee: [
      'HubSpot',
      'Salesforce',
      'Zapier',
      'Lead Scoring',
      'Lifecycle Mapping',
      'Data Hygiene',
    ],
    serviceHeading: 'System logic',
    services: [
      {
        title: 'CRM Architecture',
        description: 'Design a clean source of truth across every customer touchpoint.',
      },
      {
        title: 'Automated Nurturing',
        description: 'Trigger email and SMS flows from real user behavior.',
      },
      {
        title: 'Workflow Engineering',
        description: 'Automate repetitive internal tasks across tools and teams.',
      },
      {
        title: 'Data Intelligence',
        description: 'Improve data quality and reporting confidence with smart rules.',
      },
    ],
    showcaseHeading: 'Success profiles',
    showcase: [
      {
        title: 'Rapid Lead Response',
        description: 'Connected leads to sales reps within seconds of form completion.',
      },
      {
        title: 'Customer LTV System',
        description: 'Built post-purchase and win-back sequences for stronger retention.',
      },
      {
        title: 'Data Consolidation',
        description: 'Unified CRM, ERP, and marketing tools through custom integrations.',
      },
    ],
    testimonials: [
      'Automation gave our team more time to focus on strategic work.',
      'Our funnel stopped leaking once nurture and follow-up were systemized.',
      'Data quality improved and reporting became much more trustworthy.',
    ],
    ctaTitle: 'Ready to scale without stress?',
    ctaHighlight: 'Request a system audit',
  },
  {
    slug: 'graphic-design',
    title: 'Graphic Design',
    eyebrow: 'Est. 2026 - London',
    heroTitle: ['Architects', 'of Visual', 'Culture'],
    heroDescription:
      'We create design systems that blend brand expression, usability, and conversion thinking.',
    heroStats: [
      { value: '120+', label: 'Brand identities built' },
      { value: '55%', label: 'Lift in brand recall' },
      { value: '2s', label: 'To make first impression' },
    ],
    marquee: [
      'Brand Strategy',
      'UI/UX',
      '3D Motion',
      'Social Creatives',
      'Conversion Design',
      'Typography',
    ],
    serviceHeading: 'Creative logic',
    services: [
      {
        title: 'Brand Identity Systems',
        description: 'Develop scalable visual systems from logo to complete guidelines.',
      },
      {
        title: 'Ad Creative Design',
        description: 'Build high-impact visuals for paid and organic campaign execution.',
      },
      {
        title: 'Digital and UI Design',
        description: 'Design interfaces that look premium and remain effortless to use.',
      },
      {
        title: 'Social Content Velocity',
        description: 'Ship fast, high-quality visuals for always-on social publishing.',
      },
    ],
    showcaseHeading: 'Design grid styles',
    showcase: [
      {
        title: 'Minimalist Swiss Grid',
        description: 'Refined typography and spacing for timeless premium positioning.',
      },
      {
        title: 'Bold Asymmetrical Grid',
        description: 'High-contrast and expressive compositions for disruptive brands.',
      },
      {
        title: 'Corporate Hierarchical Grid',
        description: 'Structured systems optimized for trust and information clarity.',
      },
    ],
    testimonials: [
      'Their design system made our brand feel mature and instantly recognizable.',
      'Visual hierarchy improved both usability and campaign outcomes.',
      'The final output was beautiful, scalable, and practical for our team.',
    ],
    ctaTitle: 'Lets build your brand"s blueprint.',
    ctaHighlight: 'Book a design consultation',
  },
  {
    slug: 'email-marketing',
    title: 'Email Marketing',
    eyebrow: 'Est. 2026 - London',
    heroTitle: ['Masters', 'of First Party', 'Data'],
    heroDescription:
      'Your email list is an owned audience. We build conversion-focused lifecycle programs for recurring growth.',
    heroStats: [
      { value: '38%', label: 'Open rate lift' },
      { value: '42x', label: 'Average ROI benchmark' },
      { value: '<1%', label: 'Unsubscribe benchmark' },
    ],
    marquee: [
      'Lifecycle Marketing',
      'Behavioral Triggers',
      'Hyper-Segmentation',
      'A/B Testing',
      'List Hygiene',
      'Dynamic Personalization',
    ],
    serviceHeading: 'Inbox logic',
    services: [
      {
        title: 'Lifecycle Architecture',
        description: 'Create automated journeys from welcome to win-back.',
      },
      {
        title: 'Editorial Email Design',
        description: 'Design responsive, premium templates for high readability and action.',
      },
      {
        title: 'Behavioral Segmentation',
        description: 'Send relevant campaigns based on actions, intent, and purchase history.',
      },
      {
        title: 'Conversion Copywriting',
        description: 'Use data-backed messaging to improve click and purchase rates.',
      },
    ],
    showcaseHeading: 'Campaign showcase',
    showcase: [
      {
        title: 'Minimalist Muse',
        description: 'High-fashion style campaigns focused on brand storytelling.',
      },
      {
        title: 'Commerce Heavy',
        description: 'Offer-led layouts optimized for direct revenue.',
      },
      {
        title: 'Data Digest',
        description: 'Dense modular newsletters designed for clarity and trust.',
      },
    ],
    testimonials: [
      'Their lifecycle setup turned email into one of our strongest channels.',
      'Segmentation quality improved relevance and reduced list fatigue.',
      'We saw stronger repeat purchases after implementing their strategy.',
    ],
    ctaTitle: 'Is your email list leaving money on the table?',
    ctaHighlight: 'Request an email audit',
  },
  {
    slug: 'website-generation',
    title: 'Website Generation',
    eyebrow: 'Est. 2026 - London',
    heroTitle: ['Architects', 'of the', 'Web'],
    heroDescription:
      'We design and build high-performance websites that combine modern aesthetics with measurable conversion outcomes.',
    heroStats: [
      { value: '<1.2s', label: 'Average load time' },
      { value: '100%', label: 'Responsive fidelity' },
      { value: 'SEO', label: 'Native architecture' },
    ],
    marquee: [
      'Headless CMS',
      'Next.js Performance',
      'Webflow Experts',
      'Micro Interactions',
      'Accessibility',
      'Custom API Hooks',
    ],
    serviceHeading: 'Digital blueprint',
    services: [
      {
        title: 'Purpose-Driven UX/UI',
        description: 'Build intuitive journeys that guide users to clear actions.',
      },
      {
        title: 'Performance Engineering',
        description: 'Optimize speed and responsiveness across devices and networks.',
      },
      {
        title: 'Scalable CMS Architecture',
        description: 'Enable fast, clean content updates without developer dependency.',
      },
      {
        title: 'Immersive Interactions',
        description: 'Use motion and micro-interactions to improve engagement.',
      },
    ],
    showcaseHeading: 'Grid styles',
    showcase: [
      {
        title: 'Portfolio Grid',
        description: 'Elegant visual-first layouts for creators and premium brands.',
      },
      {
        title: 'Commerce Matrix',
        description: 'Mobile-first product architecture optimized for conversion.',
      },
      {
        title: 'Storyteller Layout',
        description: 'Narrative-driven scroll experiences with typographic impact.',
      },
    ],
    testimonials: [
      'They improved both visual quality and conversion outcomes at the same time.',
      'Our site speed and UX improvements reduced drop-off across key journeys.',
      'The final platform is flexible, scalable, and easy for our team to manage.',
    ],
    ctaTitle: 'Ready to own your corner of the web?',
    ctaHighlight: 'Start your build phase',
  },
];

export const servicePageMap = servicePages.reduce((acc, page) => {
  acc[page.slug] = page;
  return acc;
}, {});
